import {
  NumberDropdownFieldWrapper,
  NumberDropdownInput,
  NumberDropdownSelect,
} from "./style";
import { useState, useEffect } from "react";
import { NumberDropdownFieldProps } from "./interfaces";

export const NumberDropdownField = (props: NumberDropdownFieldProps) => {
  const [inputValue, setInputValue] = useState(props.value);
  const [selectValue, setSelectValue] = useState(props.defaultOption);

  useEffect(() => {
    if (props.value !== inputValue) {
      setInputValue(props.value as number);
    }
  }, [props.value]);

  useEffect(() => {
    if (props.defaultOption !== selectValue) {
      setSelectValue(props.defaultOption);
    }
  }, [props.defaultOption]);

  useEffect(() => {
    if (props.onChange) {
      const val =
        typeof inputValue === "string" ? parseInt(inputValue) : inputValue;
      if (val !== props.value || selectValue !== props.defaultOption) {
        props.onChange(val, selectValue);
      }
    }
  }, [inputValue, selectValue]);

  return (
    <NumberDropdownFieldWrapper>
      <NumberDropdownSelect
        value={selectValue}
        options={props.options}
        onChange={(value: any) => setSelectValue(value)}
        suffixIcon={props.isEditable ? undefined : null}
      />
      <NumberDropdownInput
        value={inputValue}
        onChange={(e) => {
          setInputValue(parseInt(e.target.value) || 0);
        }}
      />
    </NumberDropdownFieldWrapper>
  );
};
